import {createAction} from '@reduxjs/toolkit'
import {
  FetchBookingRequestParamsType,
  FetchBookingResponseType,
  FetchBookingHTTPResponseType
} from 'types/fetchBooking'

export const FETCH_BOOKING = 'FETCH_BOOKING'
export const FETCH_BOOKING_PENDING = 'FETCH_BOOKING_PENDING'
export const FETCH_BOOKING_DONE = 'FETCH_BOOKING_DONE'
export const FETCH_BOOKING_ERROR = 'FETCH_BOOKING_ERROR'
export const FETCH_BOOKING_FATAL_ERROR = 'FETCH_BOOKING_FATAL_ERROR'

export type FetchBookingType = {
  params: FetchBookingRequestParamsType
  type: typeof FETCH_BOOKING
}

export type FetchBookingPendingType = {
  type: typeof FETCH_BOOKING_PENDING
}

type FetchBookingErrorType = {
  data: Error
  type: typeof FETCH_BOOKING_ERROR
}

export type FetchBookingDoneType = {
  data: FetchBookingResponseType
  type: typeof FETCH_BOOKING_DONE
}

export type ActionType =
  | FetchBookingType
  | FetchBookingPendingType
  | FetchBookingDoneType
  | FetchBookingErrorType

export const fetchBooking = (
  params: FetchBookingRequestParamsType
): FetchBookingType => ({
  type: FETCH_BOOKING,
  params
})

export const fetchBookingPending = (): FetchBookingPendingType => ({
  type: FETCH_BOOKING_PENDING
})

export const fetchBookingError = (error: Error): FetchBookingErrorType => ({
  type: FETCH_BOOKING_ERROR,
  data: error
})

export const fetchBookingDone = (
  response: FetchBookingHTTPResponseType
): FetchBookingDoneType => ({
  type: FETCH_BOOKING_DONE,
  data: response.data
})

export const fetchBookingFatalError = createAction(
  'fetchBooking/fetchBookingFatalError'
)
